<mat-card *ngIf="!loading" class="mcd-card">
  <mat-card-header class="mcd-card-header">
    <mat-card-title class="mcd-card-title">View As Different Role</mat-card-title>
  </mat-card-header>
  <div class="breadcrumbs clearfix">
    <div class="breadcrumbs-inner">
      <ul>
        <li>
          <a routerLink="/global-admin-panel" routerLinkActive="active">Global Admin Panel</a>
        </li>
        <li class="separator">></li>
        <li class="active">View as Different Role</li>
      </ul>
    </div>
  </div>
  <div class="mat-card-wrapper">
    <mat-card-content class="mcd-card-content">

      <!-- Role Cards Grid -->
      <div class="role-cards-grid">

        <!-- Segment Lead Card -->
        <div class="role-card" [class.selected]="selectedRole === 'AOW Admin'"
          [class.disabled-card]="selectedRole !== '' && selectedRole !== 'AOW Admin'" (click)="selectRole('AOW Admin')">
          <div class="card-icon-wrapper green-theme">
            <img src="/assets/images/hexagon-user 1.svg" />
          </div>

          <h3 class="role-title">Segment Lead</h3>
          <p class="role-description">Manage and oversee assigned market segments</p>

          <div class="card-action-footer">
            <button type="button" class="role-action-btn" [class.btn-active]="selectedRole === 'AOW Admin'">
              View as a Segment Lead
            </button>
          </div>
        </div>

        <!-- Market Admin Card -->
        <div class="role-card" [class.selected]="selectedRole === 'Market Admin'"
          [class.disabled-card]="selectedRole !== '' && selectedRole !== 'Market Admin'"
          (click)="selectRole('Market Admin')">
          <div class="card-icon-wrapper orange-theme">
            <img src="/assets/images/shop-pin 3.svg" />
          </div>

          <h3 class="role-title">Market Admin</h3>
          <p class="role-description">Full administrative access to market settings</p>

          <div class="card-action-footer">
            <button type="button" class="role-action-btn" [class.btn-active]="selectedRole === 'Market Admin'">
              View as a Market Admin
            </button>
          </div>
        </div>

        <!-- Basic User Card -->
        <div class="role-card" [class.selected]="selectedRole === 'Basic User'"
          [class.disabled-card]="selectedRole !== '' && selectedRole !== 'Basic User'"
          (click)="selectRole('Basic User')">
          <div class="card-icon-wrapper blue-theme">
            <img src="/assets/images/circle-user 1.svg" />
          </div>

          <h3 class="role-title">Basic User</h3>
          <p class="role-description">View-only access with limited permissions</p>

          <div class="card-action-footer">
            <button type="button" class="role-action-btn" [class.btn-active]="selectedRole === 'Basic User'">
              View as a Basic User
            </button>
          </div>
        </div>

      </div>

      <!-- Dropdown Selectors Section (Shown below cards when a role is selected) -->
      <div class="dropdowns-section" *ngIf="selectedRole !== ''">
        <div class="dropdowns-row">

          <!-- Country Dropdown -->
          <div class="dropdown-col">
            <label class="dropdown-label">
              Country <span class="info-icon" matTooltip="Select country">?</span>
            </label>

            <div class="mcd-filter-dropdown-wrapper">
              <div class="mcd-dropdown-header">
                <div class="dropdown-trigger-btn" role="button" tabindex="0" (click)="toggleCountryDropdown()"
                  [style]="isCountryDropdownOpen || selectedCountryID ? 'border: 1px solid #6574C4; background: #F8F9FF;' : 'border: 1px solid #DDE1E6;'">
                  <span class="selected-count-badge" [class.has-value]="selectedCountryID">
                    {{ getSelectedCountryName() }}
                  </span>
                  <span class="trigger-chevron">
                    <img src="/assets/images/down-arrow 1.svg" height="16px" width="16px"
                      [style.transform]="isCountryDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)'"
                      [style.transition]="'transform 0.3s ease'" />
                  </span>
                </div>
              </div>

              <div class="mcd-dropdown-content" *ngIf="isCountryDropdownOpen">
                <div class="mcd-dropdown-search">
                  <mat-icon class="search-icon">search</mat-icon>
                  <input type="text" placeholder="Search" [(ngModel)]="countrySearchText" (input)="filterCountries()"
                    class="search-input" />
                </div>

                <div class="country-dropdown-options">
                  <div *ngFor="let item of filteredCountries" class="country-dropdown-option-item"
                    [class.selected]="selectedCountryID === item.id" (click)="selectCountryItem(item)">
                    {{ item.name }}
                  </div>
                  <div class="no-results" *ngIf="filteredCountries.length === 0">
                    No countries found
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- AOW Group Dropdown (Shown ONLY for Segment Lead / AOW Admin) -->
          <div class="dropdown-col" *ngIf="selectedRole === 'AOW Admin'">
            <label class="dropdown-label">
              AOW Group <span class="info-icon" matTooltip="Select AOW Group">?</span>
            </label>

            <div class="mcd-filter-dropdown-wrapper">
              <div class="mcd-dropdown-header">
                <div class="dropdown-trigger-btn" role="button" tabindex="0" (click)="toggleAowDropdown()"
                  [style]="isAowDropdownOpen || selectedAOWgrp ? 'border: 1px solid #6574C4; background: #F8F9FF;' : 'border: 1px solid #DDE1E6;'">
                  <span class="selected-count-badge" [class.has-value]="selectedAOWgrp">
                    {{ getSelectedAowName() }}
                  </span>
                  <span class="trigger-chevron">
                    <img src="/assets/images/down-arrow 1.svg" height="16px" width="16px"
                      [style.transform]="isAowDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)'"
                      [style.transition]="'transform 0.3s ease'" />
                  </span>
                </div>
              </div>

              <div class="mcd-dropdown-content" *ngIf="isAowDropdownOpen">
                <div class="mcd-dropdown-search">
                  <mat-icon class="search-icon">search</mat-icon>
                  <input type="text" placeholder="Search" [(ngModel)]="aowSearchText" (input)="filterAowGroups()"
                    class="search-input" />
                </div>

                <div class="country-dropdown-options">
                  <div *ngFor="let item of filteredAowGroups" class="country-dropdown-option-item"
                    [class.selected]="selectedAOWgrp === item.id" (click)="selectAowItem(item)">
                    {{ item.groupName }}
                  </div>
                  <div class="no-results" *ngIf="filteredAowGroups.length === 0">
                    No groups found
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <!-- Action Buttons Row (Cancel bottom-left, Submit bottom-right) -->
        <div class="actions-row">
          <button type="button" class="btn-cancel" (click)="resetSelection()">
            Cancel
          </button>

          <button type="button" class="btn-submit" (click)="viewAsRole()">
            Submit
          </button>
        </div>
      </div>

    </mat-card-content>
    <mat-card-footer class="mcd-card-footer"> </mat-card-footer>
  </div>
</mat-card>
<app-mcd-loader class="mcd-page-loader" *ngIf="loading"></app-mcd-loader>